import { render, staticRenderFns } from "./transferClassByPerson.vue?vue&type=template&id=c6cb96b8&"
import script from "./transferClassByPerson.vue?vue&type=script&lang=js&"
export * from "./transferClassByPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports